import _ from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, FormikErrors, FormikValues } from "formik";

import Navbar from "../../../../common/Navbar/Navbar";
import Layout from "../../../../common/layouts/Layout";

import { logger } from "../../../../../utils/logger";
import { useCreateIrbSubmissionMutation } from "../../../../../generated/graphql";
import { IRB_SUBMISSION_TYPES, RoutingList } from "../../../../../constants";
import CreateIRBAdditionalSubmissionForm from "./CreateIRBAdditionalSubmissionForm";
import {
  createIRBAdditionalSubInitData,
  IRBAdditionalSubmissionValidationSchema,
} from "../utils";
import useAppStore from "../../../../../states/zustand/appStore";
import { toast } from "react-toastify";
import { DocumentSubmissionDropdown } from "../../../../../types/forms/DoumentSubmission";

const ecMemberCreationSteps = ["1. Study Details", "2. MIRB Submission"];

const CreateIRBAdditionalSubmissionContainer = () => {
  const [addIRBSubmission, { loading }] = useCreateIrbSubmissionMutation();

  const navigate = useNavigate();

  const [steps, setSteps] = useState<number>(0);
  const [stepsInfo] = useState(ecMemberCreationSteps);
  const { setLoader } = useAppStore();

  useEffect(() => {
    setLoader(loading);
  }, [loading]);
  const stepHandler = (
    validateForm: (values: FormikValues) => Promise<any>,
    values: FormikValues,
    stepIndex: number,
    setErrors?: (errors: FormikErrors<FormikValues>) => void
  ) => {
    validateForm(values).then((res) => {
      if (Object.entries(res).length === 0) {
        // validation success
        const lastStepIndex = stepsInfo?.length - 1;
        if (stepIndex <= -1) {
          setSteps(0);
          return;
        } else if (steps === lastStepIndex && stepIndex > lastStepIndex) {
          saveHandler(values);
          return;
        } else if (stepIndex <= lastStepIndex) {
          setSteps((prev) => stepIndex);
          return;
        }
      } else {
        // validation failed
        logger.error(res);
        if (setErrors) {
          setErrors(res);
        }
      }
    });
  };

  const saveHandler = async (values: FormikValues) => {
    try {
      setLoader(true);
      await addIRBSubmission({
        variables: {
          type: IRB_SUBMISSION_TYPES.ADDITIONAL_SUBMISSION,
          IRBPresentation: values.IRBPresentation,
          dateOfIRBSubmission: values.dateOfIRBSubmission,
          protocolNumber: values.protocolNumber,
          micr: values.micr,
          title: values.title,
          sponsor: values.sponsor,
          principalInvestigator: values.principalInvestigator,
          department: values.department,
          emails: values.emails,
          studyPhase: values.studyPhase,
          typeOfStudy: values.typeOfStudy,
          isFunded: values.isFunded,
          fundType: values.fundType,
          documents: values.documents
            .filter((doc: DocumentSubmissionDropdown) => doc.url !== "")
            .map((doc: DocumentSubmissionDropdown ) => ({
              label: doc.dropdownSelectedValue ? doc.label + '(' + doc.dropdownSelectedValue + ')' : doc.label,
              url: doc.url,
              remark: doc.remark,
              // dropdownSelectedValue: doc.dropdownSelectedValue|| ''
            })),
        },
      });
      toast.success("MIRB Additional submission created successfully!");
    } catch (err: any) {
      toast.error(
        (err as { message: string })?.message || "Something went wrong"
      );
      logger.error(err);
    } finally {
      setLoader(false);
      navigate(RoutingList.irbAdditional.index.path);
    }
  };

  return (
    <Formik
      initialValues={_.cloneDeep(createIRBAdditionalSubInitData)}
      validationSchema={IRBAdditionalSubmissionValidationSchema[steps]}
      onSubmit={(values, { setSubmitting, setErrors, validateForm }) => {
        stepHandler(
          validateForm,
          values,
          steps > stepsInfo?.length - 1 ? steps : steps + 1,
          setErrors
        );
      }}
    >
      <Layout>
        <>
          <Navbar pageTitle="MIRB Additional Submission" />
          <CreateIRBAdditionalSubmissionForm
            steps={steps}
            setSteps={setSteps}
            stepsInfo={stepsInfo}
          />
        </>
      </Layout>
    </Formik>
  );
};

export default CreateIRBAdditionalSubmissionContainer;
